import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgExpireDurationContentProps } from './msg-expire-duration-content';
import { MsgExpireDurationContent } from './msg-expire-duration-content';

export interface MsgExpireDurationPreviewProps extends MsgExpireDurationContentProps {}

export const MsgExpireDurationPreview = memo(function MsgExpireDurationPreview({
  message,
}: MsgExpireDurationPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgExpireDurationContent message={message} />
    </LastMessageSystem>
  );
});
